import { Link, withRouter, Redirect } from "react-router-dom";
import React, {Component} from 'react';
import SalesBasketList from '../components/SalesBasketList'
import PageHeader from "../components/PageHeader";
import {  formatCurrency, formatDate, val } from '../util/HelpfulFunctions';
import i18n from "../../i18n";
import SessionManager from "../util/SessionManager";
import SalesBasketManager from "../util/SalesBasketManager";
import { EditableTile, SummaryTile } from "../components/Tiles";
import Configuration from "../util/Configuration";
import DataSource from "../util/DataSource";
import Dialog from "../components/Dialog";
import Spinner from "../components/Spinner";
import InfoText from "../components/InfoText";
import Metadata from "../util/MetadataManager";

class SalesBasket extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            transactionDate: this.getDateToday(),
            deliveryDateRequested: SalesBasketManager.getNextDeliveryDate(),
            comment: SalesBasketManager.basket.Comment,
            AEGDistributionRouteId: SalesBasketManager.basket.AEGDistributionRouteId,
            grossValue: SalesBasketManager.calcTotalGrossValue(),
            orderHeader: this.props && this.props.orderHeader,
            dummyForReloadPage: false,
            errorMessage: null,
            warningMessage: null,
            submitted: false,
            isBusy: true
        };

        SalesBasketManager.basket.DeliveryDate = this.state.deliveryDateRequested;
        this.basketModified = this.basketModified.bind(this);
        this.submitOrder = this.submitOrder.bind(this);
        this.renderSideContent = this.renderSideContent.bind(this);
        this.copyOrderToBasket = this.copyOrderToBasket.bind(this);
        this.renderThankYou = this.renderThankYou.bind(this);
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate() {
        if (!SalesBasketManager.basketIsEmpty) {
            SalesBasketManager.setBasketProperty("DeliveryDate", this.state.deliveryDateRequested);
            SalesBasketManager.setBasketProperty("Comment", this.state.comment);
            SalesBasketManager.setBasketProperty("AEGDistributionRouteId", this.state.AEGDistributionRouteId);
        }
    }

    render() {

        if (this.state.redirect) {
            return( <Redirect to={this.state.redirect} />);
        }

        if (this.state.submitted) {
            return this.renderThankYou();
        }

        return (
            <div>
                {this.renderHeader()}
                {this.renderMessage()}
                {this.renderContent()}
            </div>
        );
    }

    renderHeader() {
        return (
            <PageHeader title={this.getTitle()} sideContent={this.renderSideContent} submitCallback={this.handleSubmit} />
        );
    }

    renderContent() {
        if (this.state.isBusy) {
            return (<Spinner />);
        }
        else if (this.hasData()) {
            if (this.state.orderHeader) {
                return (this.renderOrderDetails());
            }
            else {
                return (this.renderBasket());
            }
        }
        else {
            return this.renderEmptyBasket();
        }
    }

    renderBasketORDetails() {
        if (this.state.orderHeader) {
            return (this.renderOrderDetails());
        }
        else {
            return (this.renderBasket());
        }
    }

    renderBasket() {
        return (
            <div className={"py-3 px-0"}>

                <SalesBasketList onBasketModified={this.basketModified} displayAmounts={this.displayAmounts()}  />

                {/* <div className="d-flex justify-content-right mx-0"> */}
                <div className="row d-flex justify-content-right mt-4">

                    {
                        this.displayAmounts() ?
                            (<SummaryTile size={3} title={i18n.t("Σύνολο παραγγελίας")} value={formatCurrency(this.state.grossValue)} justify="start" />)
                            :
                            null
                    }
                    
                    <EditableTile size={3} title={i18n.t("Ημερομηνία παράδοσης")} type="date" justify="start"
                        value={this.state.deliveryDateRequested}
                        onChange={Configuration.allowDeliveryDateEdit ? (event) => this.setState({ deliveryDateRequested: event.value }) : null} />
                    
                    <EditableTile size={4} title={i18n.t("Δρομολόγιο παράδοσης")} type="lookup" justify="start"
                        value={this.state.AEGDistributionRouteId}
                        itemsSource={this.state.distributionRoutes}
                        valueMember="DistributionRouteId"
                        displayMember="Description"
                        onChange={(sender) => this.setState({AEGDistributionRouteId: sender.value})} />


                    <EditableTile size={5} title={i18n.t("Σχόλια")} type="memo" justify="start"
                        value={this.state.comment} onChange={(event) => this.setState({comment: event.target.value})} />

                </div>

                {/* <div className="row mx-1">
                    <InfoText message={"Οι παραγγελίες καυσίμων που αποστέλλονται από Δευτέρα – Παρασκευή μέχρι τις 15.00 θα παραδίδονται την επόμενη εργάσιμη ημέρα."} />
                </div> */}
                
            </div>
        );
    }

    renderOrderDetails() {
        
        var formatter = Intl.DateTimeFormat(this.language, { day: "numeric", month: "numeric", year: "numeric" });

        return (
            <div className={"py-4"}>
                <SalesBasketList onBasketModified={this.basketModified}
                    detailsList={this.props.orderHeader.Details}
                    displayAmounts={this.displayAmounts()} />

                <div className="row mt-4">
    
                    <EditableTile size={3} title={i18n.t("Ημερομηνία καταχώρησης")} type="date" justify="start"
                        value={this.props.orderHeader.TransactionDate} />

                    <EditableTile size={3} title={i18n.t("Ημερομηνία παράδοσης")} type="date" justify="start"
                        value={this.props.orderHeader.DeliveryDate} />

                    <SummaryTile size={3} title={i18n.t("Δρομολόγιο παράδοσης")} textSize={1} value={this.getSelectedDistributionRouteDescr()} justify="start" />

                    {
                        this.displayAmounts() ?
                            (<SummaryTile size={4} title={i18n.t("Πληρωτέο")} justify="end"
                                subValue1={formatCurrency(this.props.orderHeader.NetValue)}
                                subTitle1={i18n.t("Καθαρή αξία")}
                                subValue2={formatCurrency(this.props.orderHeader.VATValue)}
                                subTitle2={i18n.t("Φόροι")}
                                value={formatCurrency(this.props.orderHeader.PayValue)}
                            />)
                            : null
                    }

                    {
                        this.state.comment? (<EditableTile size={4} title={i18n.t("Σχόλια")} type="memo" justify="start"
                        value={this.state.comment} />) : null
                    }
                    
                </div>

            </div>
        );
    }

    getSelectedDistributionRouteDescr() {
        if (this.props.orderHeader.AEGDistributionRouteId && this.state.distributionRoutes) {
            var selectedRoute = this.state.distributionRoutes.find(r => r.DistributionRouteId === this.props.orderHeader.AEGDistributionRouteId);
        }
        if (selectedRoute) {
            return selectedRoute.Description;
        }
        return null;
    }

    renderEmptyBasket() {

        if(localStorage.hasOwnProperty('basket'))
            localStorage.removeItem('basket');

        if (this.state.emptyBasket) {
            return;
        }
        else {
            this.setState({emptyBasket: true})
            return (
                <Dialog title={i18n.t("Το καλάθι είναι άδειο!")} 
                        message={i18n.t("Μπορείτε να προσθέστε προϊόντα από τον κατάλογο.")}
                        onConfirm={() => this.setState({redirect: "/salesOrdersProductCatalog"})}
                />
            );
        }
    }


    renderSideContent() {
        if (!SalesBasketManager.basketIsEmpty && !this.state.orderHeader) {
            return (<button onClick={this.submitOrder} name="submit" className="btn btn-success">{i18n.t("Υποβολή Παραγγελίας")}</button>);
        }
        else if (this.state.orderHeader) {
            return (
                <button className="ml-3 cmd-btn-icon btn-outline-primary2 mdi mdi-content-duplicate" 
                    title={i18n.t("Επανάληψη παραγγελίας")}
                    onClick={this.copyOrderToBasket}/>
            );
        }
    }

    renderThankYou() {
        return (
        <Dialog
            show={true}
            title={i18n.t("Ευχαριστούμε!")}
            message={i18n.t("Ευχαριστούμε για την παραγγελία σας. Θα λάβετε σύντομα ένα mail επιβεβαίωσης")}
            type="success"
            onConfirm={() => this.setState({redirect: "/dashboard" })} />
        );
    }

    renderMessage(_confirmationCallback) {

        return (
            <Dialog 
                message={this.state.errorMessage ?? this.state.warningMessage ?? this.state.inforMessage ?? this.state.questionMessage}
                type = {this.state.errorMessage? "error" : this.state.warningMessage ? "warning" : this.state.infoMessage ? "info" : this.state.questionMessage ? "question" : null}
                onConfirm={() => {
                    this.setState({errorMessage: null, warningMessage: null, infoMessage: null});
                    if (_confirmationCallback)
                        _confirmationCallback();
                }}
                />
        );
    }

    getTitle() {
        if (this.state.orderHeader){
            return i18n.t("Στοιχεία παραγγελίας" + (this.state.orderHeader? " " + this.state.orderHeader.OrderHeaderCode: ""));
        }
        else {
            return i18n.t("Καλάθι αγορών")
        }
    }

    async initialize() {

        try {
            var routes = await DataSource.query('DistributionRoute');
            var processingStatusEnum = await Metadata.getEnum("iAnywhere.Ordering.SalesOrderProcessingStatus");

            this.setState({ processingStatusEnum: processingStatusEnum, distributionRoutes: routes});
        }

        finally {
            this.setState({ isBusy: false });
        }
    }

    hasData() {
        return (!SalesBasketManager.basketIsEmpty) || this.state.orderHeader;
    }

    basketModified(){
        this.setState({ grossValue: SalesBasketManager.calcTotalGrossValue() });
    }

    async submitOrder() {

        this.setState({grossValue: SalesBasketManager.calcTotalGrossValue()});

        if (!this.validateOrder())
            return;

        Dialog.displayYesNoQuestion({
            title: i18n.t("Υποβολή παραγγελίας"),
            message: i18n.t("Πρόκειται να ολοκληρώσετε την παραγγελία σας. Μετά την οριστική υποβολή δεν θα είναι δυνατή η τροποποίησή της. Θέλετε να συνεχίσετε;"),
            confirmCallback: async () => {
                
                try {
                    this.setState({isBusy: true})
                    await SalesBasketManager.submitBasket();
                    SalesBasketManager.clearBasket();
                    this.setState({submitted: true});    
                }
                catch (error) {
                    if (error.response && error.response.data.Message === "LogoutUser") {
                        SessionManager.expireToken();
                    } else {
                        let errorMessage = error.response ? error.response.data.Message : error;
                        console.log(errorMessage);
                        this.setState({errorMessage: i18n.t("Προέκυψε κάποιο πρόβλημα κατά την υποβολή της παραγγελίας. Παρακαλώ ξαναπροσπαθήστε")});
                    }
                }
                finally {
                    this.setState({isBusy: false})
                }

                
            }
        });
    }

    validateOrder() {
        
        var validationMessage = null;

        if (!SalesBasketManager.basket.AEGDistributionRouteId)
            validationMessage = "Δεν έχετε επιλέξει δρομολόγιο παράδοσης."
            
        if (validationMessage) {
            this.setState({warningMessage: `${validationMessage}\n\r${i18n.t("Η παραγγελία δεν ολοκληρώθηκε.")}`});
            return false;
        }
        else {
            return true;
        }
    }

    async copyOrderToBasket() {

        var result = await Dialog.displayYesNoQuestion({
            title: `Επανάληψη παραγγελίας ${''}`,
            message: i18n.t("Θέλετε να επαναλάβετε την παραγγελία; Τα προϊόντα θα μεταφερθούν στο καλάθι.")
        });

        if (result === true) {
            SalesBasketManager.initFromSalesOrder(this.state.orderHeader.OrderHeaderId, () => this.setState({redirect: "/salesOrdersSalesBasket"}));
        }        
    }

    getDateToday(){
        let today = new Date();
        let year = today.getFullYear().toString();
        let month = (today.getMonth()+1).toString();
        let day = today.getDate().toString();

        if(month.length < 2)
            month = '0' + month;
        if(day.length < 2)
            day = '0' + day;
        
        return(`${year}-${month}-${day}`);
    }

    dymmyForReloadFunction(){
        this.setState({dummyForReloadPage:false});
    }

    displayAmounts() {

        if (Configuration.displayPendingAmounts) {
            return true;
        }

        if (this.props.orderHeader && this.props.orderHeader.ProcessingStatus >= this.state.processingStatusEnum.findByName("Completed").Value) {
            return true;
        }
        else {
            return false;
        }
    }
}
export default withRouter(SalesBasket);